import { Modal as ModalModule } from 'common';
import isFunction from 'lodash/isFunction';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;

const DeleteCategoryModal = ({ data: { name, onDeleteCallback }, modalId }) => {
	const onClickDeleteButton = closeModal => {
		if (isFunction(onDeleteCallback)) {
			onDeleteCallback();
		}

		closeModal();
	};

	const primaryButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Yes',
		onClick: onClickDeleteButton,
		dataqa: 'delete-category-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-category-no-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="products products-delete-category-modal warning-modal"
			header="Delete Category"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>{`Delete Category "${name}"?`}</p>
			</div>
		</Modal>
	);
};

export default DeleteCategoryModal;
